import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/src/features/3d/assets/background.webp");
;
import(/* webpackMode: "eager" */ "/app/src/features/3d/pages/Demo.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/features/auth/assets/background.webp");
;
import(/* webpackMode: "eager" */ "/app/src/features/auth/pages/Demo.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/features/dashboards/assets/background.webp");
;
import(/* webpackMode: "eager" */ "/app/src/features/dashboards/pages/Demo.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/features/device-sensors/assets/background.webp");
;
import(/* webpackMode: "eager" */ "/app/src/features/device-sensors/pages/Demo.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/features/media-capture/assets/background.webp");
;
import(/* webpackMode: "eager" */ "/app/src/features/media-capture/pages/Demo.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/features/native-integrations/assets/background.webp");
;
import(/* webpackMode: "eager" */ "/app/src/features/native-integrations/pages/Demo.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/features/offline-data-layer/assets/background.webp");
;
import(/* webpackMode: "eager" */ "/app/src/features/offline-data-layer/pages/Demo.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/features/push-notifications/assets/background.webp");
;
import(/* webpackMode: "eager" */ "/app/src/features/push-notifications/pages/Demo.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/features/pwa-core/assets/background.webp");
;
import(/* webpackMode: "eager" */ "/app/src/features/pwa-core/pages/Demo.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/features/realtime/pages/Demo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShowcasePage"] */ "/app/src/features/shared/pages/ShowcasePage.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/features/voice-interface/assets/background.webp");
;
import(/* webpackMode: "eager" */ "/app/src/features/voice-interface/pages/Demo.tsx");
